import { Device } from "@models";

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export const compareAlphabetically = (left: string, right: string) =>
  collator.compare(left, right);

export const sortDevicesByName = (devices: Device[]) =>
  [...devices].sort((left, right) => {
    const byName = compareAlphabetically(left.name, right.name);
    return byName !== 0 ? byName : compareAlphabetically(left.id, right.id);
  });
